import Controller from '../abstracts/Controller';
import 'scss-templates/t-generic-landing.scss';

export default class GenericLandingController extends Controller {
  static get COMPONENTS() {
    return [
      'EmailAddressChangeComponent'
    ];
  }
}
